module.exports = __webpack_public_path__ + "img/coin.9382997a.png";